module.exports = __webpack_public_path__ + "img/pålestikk_tredd_5.562f0f04.jpg";